/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=9957f9c0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9957f9c0&lang=scss&scoped=true"

import exportComponent from "E:\\A_Project\\TC-project\\front-abroad-tms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9957f9c0"]])

export default __exports__